<div class="container-fluid p-0">
    <!-- Header with controls: add, etc -->
    <div class="header">
      <div class="row m-0 justify-content-between">
        <!-- Tile view -->
        <div class="col col-4 pl-0 pr-0" *ngIf="fileView === ViewType.Tile">
          <app-dropdown-sort (select)="onTileSort($event)"></app-dropdown-sort>
        </div>

        <!-- Table view -->
        <div class="col col-5 pl-0 pr-0" *ngIf="fileView === ViewType.Row">
          <button type="button" class="btn btn-sm pl-0 ml-0 sort sort-filename" [class.selected]="sort === SortName.Filename" (click)="onColumnSort(SortName.Filename)">
            <span>FILE NAME</span>
            <span class="ml-1"><i class="icon icon-arrow-back-breadcrumb" [class.desc]="direction === Direction.Descending" aria-hidden="true"></i></span>
          </button>
        </div>
        <div class="col col-1 pr-0" *ngIf="fileView === ViewType.Row">
          <!--<button type="button" class="btn btn-sm pl-0 ml-0 sort sort-author" [class.selected]="sort === SortName.Type" (click)="onColumnSort(SortName.Type)">-->
          <span class=" pl-0 ml-0 sort sort-author">TYPE</span>
            <span class="ml-1"><i  [class.desc]="direction === Direction.Descending" aria-hidden="true"></i></span>
         <!-- </button>-->
        </div>
        <div class="col col-2 pr-0" *ngIf="fileView === ViewType.Row">
        <!--  <button type="button" class="btn btn-sm pl-0 ml-0 sort sort-author" [class.selected]="sort === SortName.Author" (click)="onColumnSort(SortName.Author)">-->
        <span class="pl-0 ml-0 sort sort-author">AUTHOR</span>
            <!--<span class="ml-1"><i class="icon icon-arrow-back-breadcrumb" [class.desc]="direction === Direction.Descending" aria-hidden="true"></i></span>-->
         <!-- </button>-->
        </div>
        <div class="col col-2 pr-0" *ngIf="fileView === ViewType.Row">
          <button type="button" class="btn btn-sm pl-0 ml-0 sort sort-date" [class.selected]="sort === SortName.Date" (click)="onColumnSort(SortName.Date)">
            <span>CREATED</span>
            <span class="ml-1"><i class="icon icon-arrow-back-breadcrumb" [class.desc]="direction === Direction.Descending" aria-hidden="true"></i></span>
          </button>
        </div>

        <div class="col col-2 pr-0 control">
          <app-switch-files [fileView]="ViewType.Row" (changeView)="onChangeView($event)"></app-switch-files>
        </div>
      </div>
    </div>

    <!-- Files list -->
    <div class="files-list" droppable (onDrop)="attachDocument($event)" dragHintClass="drag-hint-border">
      <div class="file-rows" *ngIf="fileView === ViewType.Row">
        <app-asset-data-table-item  *ngFor="let file of assets" [file]="file" [showRowNumber]="false" [showTypeImage]="false" (delete)="onDelete($event)" [hideDeleteButton]="!showDelete"></app-asset-data-table-item>
      </div>
      <div class="file-tiles" *ngIf="fileView === ViewType.Tile">
        <app-asset-tile *ngFor="let file of assets" class="tile" [data]="file" [showDelete]="showDelete" (delete)="onDelete($event)"></app-asset-tile>
      </div>

      <button type="button" *ngIf="!!lastEvaluatedKey" class="btn btn-link link-arrow more-results float-right text-right text-uppercase pr-0 mr-0" (click)="getNext()">
        More results<i class="icon icon-arrow-fwd-sm-link"></i>
      </button>
    </div>
</div>


